/*
 * K-Beauty Real Gems — editorial search panel.
 * Open/close + Shopify predictive search (Section Rendering API) wired into the
 * editorial layout. No custom query logic — Shopify does the querying; this only
 * fetches the rendered `krg-predictive-search` section and swaps it in.
 */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTION = 'krg-predictive-search';

  var panel = document.querySelector('[data-krg-search-panel]');
  if (!panel) return;
  var overlay = document.querySelector('[data-krg-search-overlay]');
  var input   = panel.querySelector('[data-krg-search-input]');
  var results = panel.querySelector('[data-krg-search-results]');
  var dflt    = panel.querySelector('[data-krg-search-default]');
  var body    = document.body;

  function showDefault() {
    if (results) { results.hidden = true; results.innerHTML = ''; }
    if (dflt) dflt.hidden = false;
  }
  function showResults(html) {
    if (!results) return;
    results.innerHTML = html;
    results.hidden = false;
    if (dflt) dflt.hidden = true;
  }

  function openSearch() {
    panel.classList.add('krg-search-panel--open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('krg-search-overlay--open');
    body.classList.add('krg-search-open');
    // Close the mobile nav if it's open (the mobile "Search" row lives inside it).
    var mn = document.querySelector('[data-krg-mobile-nav]');
    if (mn && mn.classList.contains('krg-mobile-nav--open')) {
      mn.classList.remove('krg-mobile-nav--open', 'krg-mobile-nav--shop');
      mn.setAttribute('aria-hidden', 'true');
      var toggle = document.querySelector('.krg-menu-toggle--open');
      if (toggle) { toggle.classList.remove('krg-menu-toggle--open'); toggle.setAttribute('aria-expanded', 'false'); }
      body.classList.remove('krg-nav-open');
    }
    if (input) { input.value = ''; showDefault(); setTimeout(function () { input.focus(); }, 120); }
  }

  function closeSearch() {
    panel.classList.remove('krg-search-panel--open');
    panel.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('krg-search-overlay--open');
    body.classList.remove('krg-search-open');
  }

  var lastCtrl = null;
  function fetchPredictive(q) {
    var url = routes + 'search/suggest?q=' + encodeURIComponent(q) +
      '&section_id=' + SECTION +
      '&resources[type]=product,article,query' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last';
    if (lastCtrl && lastCtrl.abort) lastCtrl.abort();
    lastCtrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    fetch(url, lastCtrl ? { signal: lastCtrl.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var sec = tmp.querySelector('#shopify-section-' + SECTION) || tmp;
        showResults(sec.innerHTML);
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') { /* keep default state */ } });
  }

  var debounce;
  function onInput() {
    var q = (input.value || '').trim();
    clearTimeout(debounce);
    if (!q) { showDefault(); return; }
    debounce = setTimeout(function () { fetchPredictive(q); }, 200);
  }

  // Delegated open/close so entry points work from the header or the mobile drawer.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-krg-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-krg-search-close]')) { e.preventDefault(); closeSearch(); return; }
  });
  if (overlay) overlay.addEventListener('click', closeSearch);
  if (input) input.addEventListener('input', onInput);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('krg-search-panel--open')) closeSearch();
  });
})();
